module.exports = __webpack_public_path__ + "fonts/Baloo2-Bold.f57ab981.ttf";